import { InfoCircleTwoTone } from '@ant-design/icons';
import { Tooltip } from 'antd';
import React, { ReactNode } from 'react';

interface Props {
  title?: ReactNode;
}
export const InfoTooltip: React.FC<Props> = (props) => {
  const { title } = props;

  return (
    <Tooltip title={title}>
      <InfoCircleTwoTone />
    </Tooltip>
  );
};
